/// MUI ///
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
/// STYLES ///
import { dialog_body_style } from "styles/dialog";

interface Props {
  open: boolean,
  setOpen: (open: boolean) => void,
  customer_email: string,
  save: (send_to_customer: boolean) => void
}

export default function ConfirmCustomerSending({
  open,
  setOpen,
  customer_email,
  save
}: Props) {
  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Request Signature</DialogTitle>
      <DialogContent sx={dialog_body_style}>
        <Stack sx={{ paddingTop: "10px" }}>
          <Typography variant="body2">
            Would you like to send a notification about relevant changes to the customer?
          </Typography>
          <Typography variant="body2">
            Email: {customer_email}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} size="small">Cancel</Button>
        <Button onClick={() => save(false)}>Don't Notify</Button>
        <Button onClick={() => save(true)} size="small">Notify Customer</Button>
      </DialogActions>
    </Dialog>
  )
}
